module.exports = __webpack_public_path__ + "media/images/Setting-icon-5f36b0c3a3051fb5d4087de57a851eea.png";